<template>
  <el-card>
    <el-row :gutter="35">
      <el-col :span="20">
        <el-col :span="8">
          <el-form ref="query" :model="form" :inline="true">
            <el-form-item :label="$t('clientmanage.table.merchantNo')" prop="merchantNo">
              <el-input size="small" v-model.trim="form.query.merchantNo"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="danger" @click="form.query.merchantNo = ''">{{
                $t('btns.empty')
              }}</el-button>
              <el-button size="mini" type="primary" @click="getAccountDataList">{{
                $t('btns.search')
              }}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-col>

      <el-col :span="4">
        <el-button type="primary" size="mini" @click="handleAddAccount">{{
          $t('btns.add')
        }}</el-button>
      </el-col>
    </el-row>

    <el-table
      :data="tableList"
      v-loading="tableLoading"
      stripe
      class="table"
      ref="tableList"
      id="usdtAccountListTable"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ textAlign: 'center' }"
    >
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column
        :label="$t('clientmanage.table.merchantNo')"
        prop="merchantNo"
      ></el-table-column>
      <el-table-column :label="$t('usdt.label.blockchain')" prop="usdtType"></el-table-column>
      <el-table-column :label="$t('usdt.label.wallet')" prop="usdtUrl"></el-table-column>
      <el-table-column
        :label="$t('merchantBalance.label.createAcct')"
        prop="createAcct"
      ></el-table-column>
      <el-table-column
        :label="$t('merchantBalance.label.createTime')"
        prop="createDate"
      ></el-table-column>
      <el-table-column :label="$t('clientmanage.table.operaTion')" width="200">
        <template slot-scope="scope">
          <!-- 修改 -->
          <el-tooltip
            effect="dark"
            :content="$t('usdt.label.modify')"
            placement="top"
            enterable
            v-if="permission.indexOf('merchant:usdt:account:update') > -1"
          >
            <el-popconfirm
              :ref="`popover-${scope.row.id}-1`"
              :key="`${scope.row.id}-1`"
              :title="$t('orders.tip.danger')"
              @confirm="updateUsdtAccount(scope.row)"
            >
              <el-button
                slot="reference"
                type="primary"
                icon="el-icon-edit"
                size="medium"
                circle
              ></el-button>
            </el-popconfirm>
          </el-tooltip>
          <!-- 删除 -->
          <el-tooltip
            effect="dark"
            :content="$t('usdt.label.delete')"
            placement="top"
            :enterable="false"
            v-if="permission.indexOf('merchant:usdt:account:delete') > -1"
          >
            <el-popconfirm
              :ref="`popover-${scope.row.id}-2`"
              :key="`${scope.row.id}-2`"
              :title="$t('orders.tip.danger')"
              @confirm="RemoveUSDTAccount(scope.row)"
            >
              <el-button
                slot="reference"
                type="danger"
                icon="el-icon-delete"
                size="medium"
                circle
              ></el-button>
            </el-popconfirm>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <v-pagination
      v-model="form"
      :total="tableData && tableData.rows"
      @update="getAccountDataList"
    />

    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="resetAddFormFields"
      :title="editOperate ? $t('btns.editor') : $t('btns.add')"
      width="30%"
    >
      <el-form
        :model="addForm"
        ref="createForm"
        label-width="120px"
        :inline="false"
        :rules="rules"
        style="width: 70%"
      >
        <el-form-item :label="$t('clientmanage.table.merchantNo')" prop="merchantNo">
          <el-input size="mini" v-model.trim="addForm.merchantNo" />
        </el-form-item>
        <el-form-item :label="$t('usdt.label.blockchain')" prop="usdtType">
          <el-select size="mini" v-model="addForm.usdtType">
            <el-option label="ERC-20" value="ERC20"></el-option>
            <el-option label="TRC-20" value="TRC20"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('usdt.label.wallet')" prop="usdtUrl">
          <el-input size="mini" v-model="addForm.usdtUrl" />
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="addUSDTAccount">{{
            $t('btns.confirm')
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
import usdtApi from '../../api/usdt';
import { mapGetters } from 'vuex';

export default {
  name: 'USDTAccount',
  data() {
    return {
      tableLoading: false,
      dialogVisible: false,
      form: {
        no: 1,
        size: this.$defaultPaginationSize,
        query: {
          merchantNo: ''
        }
      },
      addForm: {
        merchantNo: '',
        usdtUrl: '',
        usdtType: ''
      },
      rules: {
        merchantNo: [
          { required: true, message: this.$t('transaction.rules.merchantNo'), trigger: 'blur' }
        ],
        usdtUrl: [{ required: true, message: this.$t('usdt.rules.wallet'), trigger: 'blur' }],
        usdtType: [{ required: true, message: this.$t('usdt.rules.blockchain'), trigger: 'blur' }]
      },
      tableList: [],
      tableData: {},
      editOperate: false
    };
  },
  computed: {
    ...mapGetters(['permission'])
  },
  created() {
    this.getAccountDataList();
  },
  methods: {
    async getAccountDataList() {
      this.tableLoading = true;
      const { data } = await usdtApi.getAccountList({ data: this.form });
      if (data) {
        if (data.code == 200) {
          this.tableData = data.data;
          this.tableList = data.data && data.data.list;
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.$message.error(this.$t('status.error'));
        }
      }
    },
    handleAddAccount() {
      this.editOperate = false;
      this.addForm = this.addForm = {
        merchantNo: '',
        usdtUrl: '',
        usdtType: ''
      };
      this.dialogVisible = true;
    },
    async addUSDTAccount() {
      this.$refs.createForm.validate((valid) => {
        if (valid) {
          if (this.editOperate) {
            usdtApi.updateAccount(this.addForm).then((res) => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('status.success'));
              } else {
                this.$message.error(this.$t('status.error'));
              }
            });
          } else {
            usdtApi.createAccount(this.addForm).then((res) => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('status.success'));
              } else {
                this.$message.error(this.$t('status.error'));
              }
            });
          }
          this.getAccountDataList();
          this.dialogVisible = false;
        }
      });
    },
    async updateUsdtAccount(row) {
      this.dialogVisible = true;
      this.editOperate = true;
      this.$nextTick(() => {
        this.addForm.id = row.id;
        this.addForm.merchantNo = row.merchantNo;
        this.addForm.usdtUrl = row.usdtUrl;
        this.addForm.usdtType = row.usdtType;
      });
    },
    async RemoveUSDTAccount(row) {
      const { data } = await usdtApi.deleteAccount({ id: row.id });
      if (data.code == 200) {
        this.$message.success(this.$t('status.success'));
        this.getAccountDataList();
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    resetAddFormFields() {
      this.addForm = { merchantNo: '', usdtUrl: '', usdtType: '' };
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/usdt/account.vue